import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import landingPage from '@/components/landingPage'
import landingBooking from '@/components/landingBooking'
import roomInfo from '@/components/roomInfo'
import Login from '@/login'
import resetPassword from '@/components/resetPassword'
import registreChoice from '@/registreChoice'
import registreRoom from '@/registreRoom'
import Register from '@/register'
import { app } from '@/firebase'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/createuser',
      name: 'Create user',
      component: Register
    },
    {
      path: '/choose',
      name: 'Registration Choice',
      component: registreChoice
    },
    {
      path: '/resetpassword',
      name: 'Reset Password',
      component: resetPassword
    },
    {
      path: '/createroom',
      name: 'Create room',
      component: registreRoom
    },
    {
      path: '/menu/booking',
      name: 'LandingPage',
      component: landingPage,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/booking',
          name: 'LandingBooking',
          component: landingBooking
        },
        {
          path: '/roominfo',
          name: 'roomInfo',
          component: roomInfo
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})

router.beforeEach((to,from, next) =>{
  let currentUser = app.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('/booking')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js